import { Space, Row, Col, Popover, Avatar } from "antd";
import { FileTextOutlined, ShopOutlined, QrcodeOutlined, ProductOutlined, GiftOutlined } from "@ant-design/icons";
import { IonIcon } from "@ionic/react";
import { pricetagsOutline, fastFood, giftOutline, walletOutline, imageOutline, radioOutline } from "ionicons/icons";

const popoverConfig = {
  report: {
    title: "Report",
    content: (
      <Space direction="vertical">
        <Row style={{ width: "100%" }}>View sales reports and transaction history</Row>
        <Row style={{ width: "100%" }}>View takeaway order history</Row>
        <Row style={{ width: "100%" }}>View customer data</Row>
      </Space>
    ),
    icon: <FileTextOutlined style={{ color: "var(--ion-color-orange-600)" }} />,
    label: "Report",
  },
  shop: {
    title: "Shop",
    content: "Manage brand and shop profile",
    icon: <ShopOutlined style={{ color: "var(--ion-color-primary)" }} />,
    label: "Shop",
  },
  product: {
    title: "Product",
    content: "Manage product info, inventory",
    icon: <ProductOutlined style={{ color: "var(--ion-color-primary)" }} />,
    label: "Product",
  },
  eStamp: {
    title: "Coin",
    content: "Manage Coin Loyalty Program",
    icon: <IonIcon icon={walletOutline} style={{ color: "var(--ion-color-primary)" }} />,
    label: "Coin",
  },
  takeaway: {
    title: "Takeaway Menu",
    content: "Manage takeaway menu",
    icon: <IonIcon icon={fastFood} style={{ color: "var(--ion-color-primary)" }} />,
    label: <span style={{ fontSize: "0.75rem" }}>Takeaway Menu</span>,
    style: { marginBottom: -25 },
  },
  promotionCode: {
    title: "Promotion Code",
    content: "Manage promotion code",
    icon: <IonIcon icon={pricetagsOutline} style={{ color: "var(--ion-color-primary)" }} />,
    label: <span style={{ fontSize: "0.75rem" }}>Promotion Code</span>,
    style: { marginBottom: -25 },
  },
  redeem: {
    title: "Redeem",
    content: "Redeem product for customers",
    icon: <QrcodeOutlined style={{ color: "var(--ion-color-pink-600)" }} />,
    label: "Redeem",
  },
  eStampQR: {
    title: "Coin",
    content: "Distribute Coin to customers",
    icon: <QrcodeOutlined style={{ color: "var(--ion-color-pink-600)" }} />,
    label: "Coin",
  },
  takeawayQR: {
    title: "Takeaway",
    content: "Redeem takeaway order",
    icon: <QrcodeOutlined style={{ color: "var(--ion-color-pink-600)" }} />,
    label: "Takeaway",
  },
  welcome: {
    title: "Welcome",
    content: "Manage new joiner campaign",
    icon: <GiftOutlined style={{ color: "var(--ion-color-primary)" }} />,
    label: "Welcome",
  },
  ad: {
    title: "Ad",
    content: "Manage advertisement banner",
    icon: <IonIcon icon={imageOutline} style={{ color: "var(--ion-color-primary)" }} />,
    label: "Ad",
  },
  pushNotification: {
    title: "Push Notification",
    content: "Mange push notification",
    icon: <IonIcon icon={radioOutline} style={{ color: "var(--ion-color-primary)" }} />,
    label: <span style={{ fontSize: "0.75rem" }}>Notification</span>,
    style: { width: "4.5rem" },
  },
};

const PermissionPopover = ({ id }) => {
  const config = popoverConfig[id];

  if (!config) return null; // Handle invalid IDs

  return (
    <PopoverItem
      title={config.title}
      content={config.content}
      icon={config.icon}
      label={config.label}
      style={config.style} // Pass the optional styles
    />
  );
};

const PopoverItem = ({ title, content, icon, label, style }) => (
  <Popover content={content} title={title} trigger="hover">
    <Row
      justify="center"
      style={{
        width: "4rem",
        // background: "yellow"
        ...style,
      }}
    >
      <Col>
        <Avatar
          style={{
            fontSize: "1rem",
            padding: "1.25rem",
            background: "var(--ion-color-step-100)",
          }}
        >
          {icon}
        </Avatar>
      </Col>
      <Col span={24} style={{ textAlign: "center" }}>
        {label}
      </Col>
    </Row>
  </Popover>
);

export default PermissionPopover;
